<ion-toolbar [ngClass]="themeClass">
  <ion-grid>
    <ion-row>
      <!-- <ion-col *ngIf="!isAuthenticated()" size="2">
        <div class="search-icon" (click)="openSearch()">
          <ion-icon class="search-header"></ion-icon>
        </div>
      </ion-col> -->
      <ion-col (click)="openSearch()" size="2" class="col-search">
        <!-- <div class="search-icon-auth"> -->
          <ion-icon class="search-header"></ion-icon>
        <!-- </div> -->
      </ion-col>
      <ion-col *ngIf="this.isAuthenticated()" size="8" class="header-logo-logged">
        <img src="/../assets/img/p-b-logo.png" [ngClass]="{'PB-logo': true, 'hidden': this.isAuthenticated()}"/>
        <div
          [ngClass]="{'profile': true, 'clear': this.isAuthenticated(), 'hidden': !this.isAuthenticated()}"
          (click)="goToProfiles()">
          <div class="profile_image">
            <img *ngIf="!profileAvatar" src="{{getDefaultAvatar()}}" class="sophie" />
            <img  *ngIf="profileAvatar" src="{{profileAvatar}}" class="sophie" />
          </div>
          <div class="profile-data">
            <div class="mynews">{{'HEADER.MON_COMPTE' | translate}}</div>
            <div class="profile_name" *ngIf="!getProfileNickName()">
              {{getProfileName()}}
              <img src="/../assets/img/header-arrow-down.png" class="arrow-down" />
            </div>
            <div class="profile_name" *ngIf="getProfileNickName()">
              {{getProfileNickName()}}
              <img src="/../assets/img/header-arrow-down.png" class="arrow-down" />
            </div>
          </div>
        </div>
      </ion-col>
      <ion-col *ngIf="!isAuthenticated()" size="8" class="header-logo">
        <div [ngClass]="{'PB-logo': true, 'hidden': isAuthenticated()}" (click)="goHome()" ></div>
        <div
          [ngClass]="{'profile': true, 'clear': isAuthenticated(), 'hidden': !isAuthenticated()}"
          (click)="goToProfiles()" >
          <div class="profile_image">
            <img *ngIf="!profileAvatar" src="/../assets/img/default_avatar.png" class="sophie" />
            <img *ngIf="profileAvatar" src="{{profileAvatar}}" class="sophie" />
          </div>
          <div class="mynews">{{'HEADER.MON_COMPTE' | translate}}</div>
          <div class="profile_name">
            {{getProfileName()}}
            <img src="/../assets/img/header-arrow-down.png" class="arrow-down" />
          </div>
        </div>
      </ion-col>
      <ion-col *ngIf="!isAuthenticated() && themeClass !== 'clfy'" size="2"  style="text-align: right" (click)="goToLogin()" >
        <ion-icon class="user"></ion-icon>
      </ion-col>
      <ion-col *ngIf="isAuthenticated()" size="2" style="text-align: right" (click)="goToLogin()"></ion-col>
    </ion-row>
  </ion-grid>
</ion-toolbar>
<ion-item lines="none" [ngClass]="themeClass" *ngIf="!isAbboner() && !search && themeClass !== 'clfy'" (click)="goToBoutique()" class="BG-Header-copy-2">
  <span class="Sabonner-AUX-JOURNAUX">{{'HEADER.S_ABONNER_AUX_JOURNAUX' | translate}}
    <img class="banner-action-arrow" src="/../assets/img/icon-arrow-abo-copy.png" class="Icon-Arrow-Abo-copy" />
  </span>
</ion-item>
<!-- <div *ngIf="!isAbboner() && !search && (themeClass === 'playbacpresse' || themeClass === 'lepq' || themeClass === 'mquo')" (click)="goToLogin()" class="devoir">
  <span class="devoir-icon"></span><span>Accès GRATUIT</span><span class="right-black-arrow-icon"></span>
</div> -->
<ion-grid class="grid-search" *ngIf="search">
  <ion-row class="row-search">
    <ion-col size="10">
      <ion-list class="ion-no-padding clear">
        <form>
          <ion-item [ngClass]="themeClass" lines="none" class="search">
            <ion-input [ngModel]="model.search_string" type="text" name="search" placeholder="{{ 'HEADER.PLACEHOLDER' | translate }}" #search_input="ngModel"></ion-input>
          </ion-item>
        </form>
      </ion-list>
    </ion-col>
    <ion-col size="2">
      <div class="search-button">
        <ion-icon (click)="doSearch(search_input.value)" class="search-header"></ion-icon>
        <div class="annuler" [ngClass]="themeClass" (click)="search = !search;"> {{ 'SEARCH.CANCEL' | translate }} </div>
      </div>
    </ion-col>
  </ion-row>
</ion-grid>
<!-- <div *ngIf="!authService.isAuthenticated() && (themeClass === 'lepq' || themeClass === 'mquo' || themeClass === 'actu')"
  (click)="goToJOLandingPage()" class="devoir-banner">
    <div class="devoir-banner-text">Dossiers Spécial Jeux Olympiques de Paris 2024.</div>
    <div class="devoir-button">J'en profite</div>
</div> -->

<!--  -->
<!-- <div class="devoir-banner" (click)="goToLoginPage()"
  *ngIf="!this.authService.isAuthenticated() && (themeClass === 'lepq' || themeClass === 'mquo' || themeClass === 'actu' || themeClass === 'aeco' || themeClass ==='playbacpresse')">
    <div class="devoir-banner-text">Gratuit: 1 semaine d’abonnement</div>
    <div class="devoir-button">J'en profite</div>
</div> -->

